export function setFocusToEnd(ref) {
    const range = document.createRange();
    const selection = document.getSelection();

    range.selectNodeContents(ref.current);
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
};
